<div class="document-history-item" [class.open]="isOpen">
    <div class="item-header">
        <div class="item-title" [matTooltip]="document.name" matTooltipShowDelay="300">
            {{ document.name }}
        </div>
        @if (document.documentId) {
            <cerrix-icon-button
                class="item-download"
                color="accent-link"
                size="small"
                (click)="onDownload()"
            >
                <mat-icon fontSet="material-symbols-outlined">cloud_download</mat-icon>
            </cerrix-icon-button>
        }
        <cerrix-icon
            class="item-collapse"
            icon="dropdown-closed"
            color="#001257"
            [size]="8"
            (click)="toggleAccordion()"
        ></cerrix-icon>
    </div>
    <div class="item-details">
        <div class="item-details-row">
            <div class="item-details-row-title">User</div>
            <div class="item-details-row-value">{{ document.uploadedBy }}</div>
        </div>
        <div class="item-details-row">
            <div class="item-details-row-title">Date</div>
            <div class="item-details-row-value">
                {{ document.modifiedOn ?? document.createdOn | dateTimeDisplay: true }}
            </div>
        </div>
        <div class="item-details-row">
            <div class="item-details-row-title">Type</div>
            <div class="item-details-row-value">{{ document.documentTypeId }}</div>
        </div>
        <div class="item-details-row">
            <div class="item-details-row-title">Description</div>
            <div class="item-details-row-value">
                {{ document.description }}
            </div>
        </div>
        <div class="item-details-row">
            <div class="item-details-row-title">File size</div>
            <div class="item-details-row-value">{{ document.fileSize }}</div>
        </div>
    </div>
</div>
